<template>
  <div class="basic_wrap">
    <div class="login_bg auth-header">
      <button
        type="button"
        class="auth-back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('register.register') }}</h1>
      <button
        type="button"
        class="language"
        @click="$router.push('/language')"
      >
        <img
          :src="require('../images/language/'+lang+'.png')"
          alt=""
        >
      </button>
    </div>
    <div class="login_logo">
      <img
        class="logo"
        src="../images/shop2/logo.png"
      >
    </div>
    <div class="form">
      <!-- 	<div class="cut_login">
				<router-link to="/login">
					{{$t('register.signIn')}}
					<div class="line" />
				</router-link>
				<router-link class="cur" to="/register">
					{{$t('register.signUp')}}
					<div class="line" />
				</router-link>
			</div> -->
      <div class="item">
        <span class="icon">
          <van-icon
            name="phone-o"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.phone"
          type="tel"
          inputmode="numeric"
          maxlength="20"
          class="inp"
          :placeholder="$t('register.phoneNumber')"
        >
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          :placeholder="$t('register.password')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          :placeholder="$t('register.spassword')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <!-- <div class="item">
                <input type="text" class="inp" v-model.trim="data.code" :placeholder="$t('forgetpwe.code')"/>
                <van-count-down :time="time" format='mm:ss' class="btn get_captcha" @finish="timeCall">
                    <template v-slot="timeData">
                        <span @click="sendcode">{{timeData.seconds > 0 ? (timeData.minutes+':'+timeData.seconds): $t('forgetpwe.send')}}</span>
                    </template>
                </van-count-down>
            </div> -->
      <!-- <div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->
      <template>
        <div class="item">
          <span class="icon">
            <van-icon
              name="friends-o"
              size="25"
            />
          </span>
          <input
            v-model.trim="data.t_mobile"
            type="text"
            class="inp"
            :placeholder="$t('register.referralCode')"
          >
        </div>
      </template>
      <div class="item_reset_pwd">
        <van-checkbox-group
          v-model="checked"
          shape="square"
        >
          <van-checkbox
            name="a"
            checked-color="#fc494d"
            style="height: 35px;"
          >
            {{ $t('d.least18') }}
          </van-checkbox>
          <van-checkbox
            name="b"
            checked-color="#fc494d"
            style="height: 35px;"
          >
            {{ $t('d.acceptc') }}
            <a
              href="/#/about/35"
              class=""
              style="margin-left: 4px;"
            >
              {{ $t('d.terms') }}
            </a>
          </van-checkbox>
        </van-checkbox-group>
      </div>
			
      <div
        class="basic_btn sbtn"
        :class="
          data.phone == '' ||
            data.password == '' ||
            data.spassword != data.password
            ? 'no_touch'
            : ''
        "
        @click="submit"
      >
        {{ $t('register.register') }}
      </div>
      <div class="register">
        {{ $t('register.signIn') }}<router-link
          class="link"
          to="/login"
        >
          {{ $t('register.signUp') }}
        </router-link>
      </div>
    </div>
		
    <van-dialog
      v-model="statement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="privacyStatementHide"
    />
    <van-dialog
      v-model="agreement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="agreementHider"
    />
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/shop2/kefu.jpg"
      >
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Icon,
		CountDown,
		RadioGroup, 
		Radio,
		Checkbox, 
		CheckboxGroup,
		Dialog
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(CountDown)
		.use(Icon)
		.use(RadioGroup)
		.use(Radio)
		.use(Checkbox)
		.use(CheckboxGroup)
		.use(Dialog);

	export default {
		name: "Register",
		data() {
			return {
				time: 0,
				agreement: false,
				lang:this.$i18n.locale||"en_us",
				statement: false,
				show_kefu: false,
				msg_show: true,
				sex:"1",
				show_sms: 0,
				// checked:['a', 'b'],
				checked:[],
				password: "password",
				data: {
					password: "",
					spassword: "",
					paypwd: "",
					phone: "",
					t_mobile: "",
					telacc: "",
					code: "",
					agent: 10000
				},
				config: {}
			};
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
			// 安卓返回IMEI，苹果返回UID值
			/*BSL.PhoneID('callName');
			window.callName = this.methodName;
			// 获取手机OAID
			BSL.GetOAID('getExternalInfo');
			window.getExternalInfo = this.getExternalInfoData; */
		},
		mounted() {
			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			document.body.addEventListener("scroll", this.hideKefuOnScroll, false);
			document.addEventListener("click", this.hideKefuOnOutsideClick, false);
			Fetch('/index/webconfig', {
				type: 'web'
			}).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
		},
		beforeDestroy() {
			document.body.removeEventListener("scroll", this.hideKefuOnScroll, false);
			document.removeEventListener("click", this.hideKefuOnOutsideClick, false);
		},
		methods: {
			hideKefuOnScroll() {
				this.show_kefu = false;
			},
			hideKefuOnOutsideClick(ev) {
				if (ev.target.className != "kefu_img") {
					this.show_kefu = false;
				}
			},
			kefu_to() {
				if (this.show_kefu) {
					this.$router.push("/kefu2");
				}
				this.show_kefu = !this.show_kefu;
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				const externalInfo = JSON.parse(info);
				console.log(externalInfo);
				if (externalInfo.code == 0) {
					this.data.oaid = externalInfo.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				if(m && parseInt(m)>0){
					localStorage.setItem('t_mobile', m);
					this.data.t_mobile = m;
				}else{
					if (localStorage.getItem('t_mobile')) {
						this.data.t_mobile = localStorage.getItem('t_mobile');
					}
				}
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				if (!this.data.phone) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				if (!this.isValidPhone()) {
					this.$toast(this.$t('login.phoneError'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
						phone: this.data.phone,
					})
					.then(() => {
						this.time = 120 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				if (!this.data.phone) {
					this.$toast(this.$t('register.phoneEmpty'));
					return false;
				}
				if (!this.isValidPhone()) {
					this.$toast(this.$t('login.phoneError'));
					return false;
				}
				if (!this.data.password) {
					this.$toast(this.$t('register.passwordEmpty'));
					return false;
				}
				if (!this.data.t_mobile || this.data.t_mobile.length<3) {
					this.$toast(this.$t('d.codeno'));
					return false;
				}
				// if (!this.data.spassword) {
				//     this.$toast(this.$t('register.passwordAgainEmpty'));
				//     return false;
				// }

				if (!this.data.code && this.config.sms_verify) {
					this.$toast(this.$t('register.codeEmpty'));
					return false;
				}
				if (this.data.password != this.data.spassword) {
					this.$toast(this.$t('register.passwordError'));
					return false;
				}
				if(this.checked.length!=2){
					this.$toast(this.$t('d.acceptc'));
					return false;
				}
				Fetch("/index/register", {
					password: this.data.password,
					spassword: this.data.spassword,
					paypwd: this.data.paypwd,
					phone: this.data.phone,
					t_mobile: this.data.t_mobile,
					telacc: this.data.telacc,
					code: this.data.code,
					agent: this.data.agent
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast(this.$t('register.signUpSuccess'));
					this.$router.replace("/");
				});
			},
			isValidPhone() {
				return /^\d{6,20}$/.test(this.data.phone);
			},
			userAgreement() {
				this.agreement = true;
			},
			agreementHider() {
				this.agreement = false;
			},
			privacyStatement() {
				this.statement = true;
			},
			privacyStatementHide() {
				this.statement = false;
			},
			changeLang(lang) {
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$toast.loading({
					// mask: true,
					message: this.$t('utils.loading'),
					duration: 200
				})
				this.$router.go(-1);
			}
		},
	};
</script>

<style lang="less" scoped>
	.login_bg {
		width: 100%;
		height: 48px;
		background: none;
		background-size: 100% 100%;
		overflow: hidden;
		position: relative;
		.language{
			position: absolute;
			top: 4px;
			right: 0;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}

	.basic_wrap .form {
		margin: 5px auto 0 auto;
		width: 95%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 13px;
		padding: 31px 24px 31px 24px;
	}

	.cut_login {
		width: 207px;
		line-height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		text-align: center;
		margin: 0 auto;

		a {
			width: 50%;
			padding-bottom: 10px;
			color: #808080;
			position: relative;

			.line {
				width: 100%;
				height: 1px;
				position: absolute;
				left: 0;
				bottom: 0;
				background-color: #f2f2f2;
			}
		}

		a.cur {
			color: #D20100cc;

			.line {
				height: 2px;
				background-image: linear-gradient(to right, #f90, #f18a11);
			}
		}
	}
	.big_tit{
		color: #000;
	}
	.block {
		width: 100%;
		height: 100%;
		// overflow:hidden;
		// margin: 10% auto;
		font-size: 15px;
		justify-content: center;
		background-color: #fff;
		border-radius: 5px;

		.block-title {
			display: block;
			font-weight: bolder;
			line-height: 39px;
			height: 39px;
			text-align: center;
		}

		.p_agr {
			// padding-top:30rpx;
			font-size: 12px;
			/*font-weight: bolder;*/
			line-height: 20px;
			padding: 0px 10px;
			height: 388px;
			/*overflow: hidden;*/
			// overflow: auto;
			-webkit-overflow-scrolling: touch;
			overflow-y: scroll;
		}

		.div_qd {
			width: 60px;
			height: 25px;

			span {
				width: 60px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				justify-content: center;
				background: #fb661e;
				border-radius: 10px;
				padding: 1px 5px;
				color: #fff;
			}

			margin: 10px auto;
		}
	}

	.item {
		height: 58px;
		border-bottom: 1px solid #f0f1f3;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		padding-bottom: 4px;

		.icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 28px;
			height: 24px;

			.people {
				width: 23px;
				height: 20px;
			}

			img {
				height: 100%;
			}
		}

		input {
			height: 20px;
			margin-left: 7px;
			flex: 1;
			margin-bottom: 3px;
		}
	}

	.get_captcha {
		width: 88px;
		height: 34px;
		background: linear-gradient(90deg,
				rgba(228, 57, 46, 1) 0%,
				rgba(254, 76, 22, 1) 100%);
		border-radius: 4px;
		text-align: center;
		line-height: 34px;
		font-size: 14px;
		color: #ffffff;
	}

	.protocol {
		font-size: 12px;
		line-height: 17px;
		margin-top: 20px;
		color: #999999;

		a {
			color: #3d96ff;
		}
	}

	.basic_btn {
		margin: 36px auto 0 auto;
	}
	/deep/ .van-icon {
	}
	.register{
		line-height: 5%;
		text-align: center;
		margin-top: 30px;
		font-size: 12px;
	}
	
	.basic_wrap {
		max-width: 750px;
		background: url(../images/shop2/1.png) repeat top;
		height: 100vh;
		padding-bottom: 10%;
		background-color: #FFF;
		filter: opacity(80%);
		background-position: 50%;
		background-size: cover;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
	}
	.area_code{
		font-size: 16px;
		line-height: 20px;
		padding: 5px;
	}

	.basic_wrap {
		min-height: 100vh;
		padding-bottom: 0;
		background: #fff;
		filter: none;
	}
	.login_bg.auth-header {
		display: flex;
		height: 50px;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #f1f1f1;
		background: #fff;
	}
	.auth-header h1 {
		margin: 0;
		color: #222;
		font-size: 17px;
		font-weight: 500;
		line-height: 24px;
	}
	.auth-back,
	.login_bg.auth-header .language {
		position: absolute;
		top: 0;
		display: flex;
		width: 50px;
		height: 50px;
		align-items: center;
		justify-content: center;
		padding: 0;
		border: 0;
		background: transparent;
		color: #ee4d2d;
		font-size: 23px;
	}
	.auth-back { left: 0; }
	.login_bg.auth-header .language { right: 0; }
	.login_bg.auth-header .language img { width: 28px; height: 28px; object-fit: contain; }
	.login_logo {
		width: 100%;
		margin-top: 34px;
		text-align: center;
		-webkit-animation: none;
		animation: none;
	}
	.login_logo img {
		width: 62px;
		max-height: 72px;
		margin: 0;
		-webkit-animation: none;
		animation: none;
		object-fit: contain;
	}
	.form { -webkit-animation: none; animation: none; }
	.basic_wrap .form {
		width: auto;
		margin: 30px 29px 0;
		padding: 0;
		border-radius: 0;
		box-shadow: none;
	}
	.item {
		height: 57px;
		box-sizing: border-box;
		align-items: center;
		padding: 0 8px;
		border-bottom-color: #d9d9d9;
	}
	.item .icon {
		display: flex;
		width: 30px;
		height: 100%;
		align-items: center;
		justify-content: flex-start;
		color: #666;
	}
	.item input {
		height: 100%;
		margin: 0 0 0 10px;
		color: #333;
		font-size: 15px;
	}
	.item input::placeholder { color: #a8afb8; font-weight: 400; }
	.eye_bi { margin-left: 8px; opacity: .7; }
	.item_reset_pwd { margin-top: 16px; color: #555; font-size: 13px; line-height: 20px; }
	/deep/ .van-checkbox__label { color: #555; font-size: 13px; font-weight: 400; }
	/deep/ .van-checkbox__icon--checked .van-icon { border-color: #ee4d2d; background-color: #ee4d2d; }
	.basic_btn,
	.basic_btn.sbtn {
		width: 100%;
		height: 44px;
		margin: 28px 0 0;
		border-radius: 4px;
		background: #ee4d2d;
		box-shadow: none;
		color: #fff;
		font-size: 15px;
		font-weight: 500;
		line-height: 44px;
	}
	.basic_btn.no_touch { background: #ededed; color: #a8afb8; }
	.register { margin-top: 28px; color: #666; font-size: 14px; line-height: 22px; }
	.register .link { margin-left: 4px; color: #ee4d2d; font-weight: 500; }
</style>
